import {Subscription} from "rxjs";
import {AddToRouteComponentStore} from "../../angular/state/add-to-route.store";

// services-assign-route-table.html binds its `list` input to md-virtual-repeat/md-on-demand,
// which requires a plain object with getItemAtIndex/getLength/isEmpty/isFetching - it can't
// consume AddToRouteComponentStore's observables directly. This adapts the store's state to
// that contract without rewriting the (AngularJS) table itself.
export class RoutesListAdapter {
  private state: { routes: any[], cursor?: string, loading: boolean } = {routes: [], loading: false};
  private sub: Subscription;

  constructor(private store: AddToRouteComponentStore, private limit: number, private getParams: () => any) {
    this.sub = store.vm$.subscribe((vm) => this.state = vm);
  }

  getItemAtIndex(index) {
    if (this.state.routes[index]) {
      return this.state.routes[index];
    } else if (!this.state.loading && this.state.cursor) {
      this.store.getRoutes(this.getParams());
    }
  }

  getLength() {
    return (this.state.loading || !this.state.cursor) ? this.state.routes.length : this.state.routes.length + this.limit;
  }

  isEmpty() {
    return !this.state.routes.length;
  }

  isFetching() {
    return this.state.loading;
  }

  destroy() {
    this.sub.unsubscribe();
  }
}
